module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTQuMTIyIDEyNy44OTJ2LTI4LjY4SDcuNTEzVjg3LjI3NGg0Ni42MDl2LTEyLjRINy41MTN2LTEyLjg2aDM4LjAwM0wuMDk5IDBoMjIuNmwzMi41NTYgNDUuMDdjMy42MTcgNS4xNDQgNi40NCA5LjYxMSA4LjQ4NyAxMy4zODUgMS43ODgtMy4wNSA0Ljg5LTcuNzc5IDkuMzAxLTE0LjE4NkwxMDMuOTMgMGgyNC4wMUw4Mi4zODUgNjIuMDEzaDM4LjM0djEyLjg2MmgtNDYuNDF2MTIuNGg0Ni40MXYxMS45MzdoLTQ2LjQxdjI4LjY4SDU0LjEyM3oiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/money.svg
// module id = IF5j
// module chunks = 30